'use strict';

var _ = require('lodash');
var HoverOver = function HoverOver() {
  return function () {
    var chartModel;
    var scales;
    var tip;
    var chartParams;

    /**
     * Hover over focus indicator
     */
    var focus;

    /**
     * Adds SVG element for hover over focus indicator
     * @param container
     */
    function addFocus(container) {
      // remove old focus element
      container.selectAll('g.focus').remove();

      // focus elements
      focus = container.append('g').attr('class', 'focus').style('display', 'none');

      // focus circle
      focus.append('circle').attr('class', 'focus-circle first-circle').attr('r', 4.5);

      // focus x line
      // append the x line
      focus.append('line').attr('class', 'x-focus-line').attr('y1', 0).attr('y2', 1);
    }
    function findPoint(coordX) {
      var xSeatIndex = scales.xScale.invert(coordX);
      var segmentGroups = chartModel.getBidPricesList();
      return _.find(segmentGroups, {
        seatAvailIndex: Math.floor(xSeatIndex)
      });
    }
    var hoverOver = function hoverOver(container) {
      addFocus(container);
    };
    hoverOver.hideFocus = function () {
      focus.style('display', 'none');
    };
    hoverOver.moveFocus = function (mouseCoordX) {
      var translateX;
      var dataPoint = findPoint(mouseCoordX); // jshint ignore:line

      // when there is at least one data point
      if (dataPoint) {
        focus.style('display', null);
        translateX = scales.xScale(dataPoint.seatAvailIndex);

        // move first-circle
        focus.select('.first-circle').attr('transform', 'translate(' + translateX + ',' + scales.yScale(dataPoint.bidPrice) + ')');

        // move focus line
        focus.select('.x-focus-line').attr('transform', 'translate(' + translateX + ', 0)').attr('y2', chartParams.height - chartParams.chartPadding.bottom);

        // offset and show tooltip
        tip.offset(function () {
          return [0, scales.xScale(dataPoint.seatAvailIndex) - chartParams.width / 2];
        });
        tip.show(dataPoint);
      } else {
        // hide focus and tip
        focus.style('display', 'none');
        tip.hide();
      }
    };
    hoverOver.chartModel = function (value) {
      if (!arguments.length) {
        return chartModel;
      }
      chartModel = value;
      return hoverOver;
    };
    hoverOver.scales = function (value) {
      if (!arguments.length) {
        return scales;
      }
      scales = value;
      return hoverOver;
    };
    hoverOver.tip = function (value) {
      if (!arguments.length) {
        return tip;
      }
      tip = value;
      return hoverOver;
    };
    hoverOver.chartParams = function (value) {
      if (!arguments.length) {
        return chartParams;
      }
      chartParams = value;
      return hoverOver;
    };
    return hoverOver;
  };
};
HoverOver.$inject = [];
module.exports = HoverOver;